import React from 'react'
import './checkout.css'
import { Subtotal } from '../index'
import { useStateValue } from '../../StateProvider'
import CheckoutProduct from './CheckoutProduct'

function Checkout() {
	const [{ basket, user }, dispatch] = useStateValue()

	return (
		<div className='checkout'>
			<div className='checkout__left'>
				<img
					className='checkout__ad'
					src='https://images-na.ssl-images-amazon.com/images/G/02/UK_CCMP/TM/OCC_Amazon1._CB423492668_.jpg'
					alt=''
				/>
				<div>
					<h3>Hello,{user ? user.displayName : 'Guest'}</h3>
					<h2 className='checkout__title'>Your shopping Basket</h2>
					<div className='product__container'>
						{basket.map((item, index) => (
							<CheckoutProduct {...item} />
						))}
					</div>
				</div>
			</div>
			<div className='checkout__right'>
				<Subtotal />
			</div>
		</div>
	)
}

export default Checkout
